export default __webpack_public_path__ + "static/media/Vila-Casa.f9680f30.png";